import React from 'react';
import cn from 'classnames';
import { Button, type ButtonProps } from '../Button';
import * as styles from './styles.module.css';

export const IconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size = 'large', ...props }, ref) => (
    <Button
      ref={ref}
      className={cn(styles.onlyIcon, styles[size], className)}
      size={size}
      {...props}
    />
  )
);
